// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const RockyLinuxIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 256 256">
    <path
      fill="#10B981"
      fillRule="evenodd"
      d="M243.84 168.45a123 123 0 0 0 6.83-40.45C250.67 60.25 195.75 5.33 128 5.33S5.33 60.25 5.33 128c0 33.52 13.45 63.9 35.24 86.04L165 89.61l30.72 30.72zm-22.4 39.03L165 151.05l-88.37 88.37A122 122 0 0 0 128 250.67a122.4 122.4 0 0 0 93.43-43.19"
      clipRule="evenodd"
    />
  </svg>,
  "RockyLinux",
);
export default RockyLinuxIcon;
